// Unpublished Work © 2023 Deere & Company.

import t from 'tcomb';

export const IndividualNameLogs = t.struct({
    birthDate: t.String,
    businessName1: t.String,
    businessName2: t.String,
    dbaName: t.String,
    familiarName: t.String,
    firstName: t.String,
    generationName: t.String,
    lastName: t.String,
    middleName: t.String,
    modifiedBy: t.String,
    prefixName: t.String,
    remark: t.String,
    suffixName: t.String,
    timeStamp: t.String
}, {
    defaultProps: {
        birthDate: '',
        businessName1: '',
        businessName2: '',
        dbaName: '',
        familiarName: '',
        firstName: '',
        generationName: '',
        lastName: '',
        middleName: '',
        modifiedBy: '',
        prefixName: '',
        remark: '',
        suffixName: '',
        timeStamp: ''
    },
    name: 'IndividualNameLogs',
    strict: true
});
